import React from 'react'
import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { isLayerEnvironment, type LayerEnvironment } from '../layerEnvironments'
import { FourOhFour } from './404'

type EnvironmentContextType = {
  environment: LayerEnvironment
}

export const useEnvironment = () => {
  return useOutletContext<EnvironmentContextType>()
}

export const Environment = () => {
  const { environment } = useParams<{ environment: string }>()

  if (!isLayerEnvironment(environment)) {
    return <FourOhFour />
  }

  return <Outlet context={{ environment }} />
}
